import { minutesToMilliseconds } from 'date-fns';

import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import { type GetAppointmentSettingsRequest } from '@service-initiation/shared-clients-tech-care-services';
import { queryClient } from '@service-initiation/shared-utils-query-client';

import { techCareServicesClient } from './clients/techCareServicesClient';
import { type AppointmentDate } from './types/AppointmentDate';
import { ubifAppointmentToTechCareAppointment } from './utils/ubifAppointmentToTechCareAppointment';

export const GET_OPEN_APPOINTMENTS_CACHE_KEY = 'appointmentSettings';

export const getOpenAppointments = async (
  request?: GetAppointmentSettingsRequest
): Promise<AppointmentDate[]> => {
  try {
    const response = await queryClient.fetchQuery({
      queryFn: async () => {
        const response = await techCareServicesClient.getAppointmentSettings(
          request
        );

        if (response.status !== HttpStatusCodes.OK) {
          throw new Error('Received invalid response status from server.');
        }

        if (
          !response.body?.open_appointments ||
          !response.body?.open_appointments.length
        ) {
          throw new Error('Failed to fetch appointment settings.');
        }

        return response.body;
      },
      queryKey: [GET_OPEN_APPOINTMENTS_CACHE_KEY, request],
      retry: 2,
      staleTime: minutesToMilliseconds(5),
    });

    return response.open_appointments.map((openAppointment) =>
      ubifAppointmentToTechCareAppointment(openAppointment, response.blackouts)
    );
  } catch (e) {
    const err = e as Error;
    err.message = 'Error occurred while trying to fetch appointment settings';
    logger.error(err, {
      data: request,
    });
    throw err;
  }
};
